import * as tokens from '@audi/audi-ui-design-tokens';
export const colors = {
    form: {
        primary: tokens.COLOR_FORM_PRIMARY_DARK,
        secondary: tokens.COLOR_FORM_SECONDARY_DARK,
        tertiary: tokens.COLOR_FORM_TERTIARY_DARK,
        strong: tokens.COLOR_FORM_STRONG_DARK,
        error: tokens.COLOR_FORM_ERROR_DARK,
        muted: {
            primary: tokens.COLOR_FORM_MUTED_PRIMARY_DARK,
            secondary: tokens.COLOR_FORM_MUTED_SECONDARY_DARK,
            tertiary: tokens.COLOR_FORM_MUTED_TERTIARY_DARK,
        },
    },
    text: {
        primary: tokens.COLOR_TEXT_PRIMARY_DARK,
        secondary: tokens.COLOR_TEXT_SECONDARY_DARK,
        inactive: tokens.COLOR_TEXT_INACTIVE_DARK,
        error: tokens.COLOR_TEXT_ERROR_DARK,
    },
    ui: {
        accent: tokens.COLOR_BASE_BRAND_PROGRESSIVE_RED,
        disabled: tokens.COLOR_UI_DISABLED_DARK,
        divider: {
            primary: tokens.COLOR_UI_DIVIDER_PRIMARY_DARK,
        },
        error: tokens.COLOR_UI_ERROR_DARK,
        success: tokens.COLOR_UI_SUCCESS_DARK,
        hover: tokens.COLOR_UI_HOVER_DARK,
        primary: tokens.COLOR_UI_PRIMARY_DARK,
        primaryInverse: tokens.COLOR_UI_PRIMARY_INVERSE_DARK,
    },
    utility: {
        white: tokens.COLOR_UTILITY_WHITE_DARK,
        black: tokens.COLOR_UTILITY_BLACK_DARK,
        neutral: {
            0: tokens.COLOR_UTILITY_NEUTRAL_0_DARK,
            5: tokens.COLOR_UTILITY_NEUTRAL_5_DARK,
            10: tokens.COLOR_UTILITY_NEUTRAL_10_DARK,
            15: tokens.COLOR_UTILITY_NEUTRAL_15_DARK,
            20: tokens.COLOR_UTILITY_NEUTRAL_20_DARK,
            30: tokens.COLOR_UTILITY_NEUTRAL_30_DARK,
            40: tokens.COLOR_UTILITY_NEUTRAL_40_DARK,
            50: tokens.COLOR_UTILITY_NEUTRAL_50_DARK,
            60: tokens.COLOR_UTILITY_NEUTRAL_60_DARK,
            70: tokens.COLOR_UTILITY_NEUTRAL_70_DARK,
            80: tokens.COLOR_UTILITY_NEUTRAL_80_DARK,
            90: tokens.COLOR_UTILITY_NEUTRAL_90_DARK,
            100: tokens.COLOR_UTILITY_NEUTRAL_100_DARK,
        },
    },
    notification: {
        neutral: tokens.COLOR_NOTIFICATION_NEUTRAL_DARK,
        error: tokens.COLOR_NOTIFICATION_ERROR_DARK,
        warning: tokens.COLOR_NOTIFICATION_WARNING_DARK,
        success: tokens.COLOR_NOTIFICATION_SUCCESS_DARK,
    },
    option: {
        primary: tokens.COLOR_OPTION_PRIMARY_DARK,
        secondary: tokens.COLOR_OPTION_SECONDARY_DARK,
        tertiary: tokens.COLOR_OPTION_TERTIARY_DARK,
        disabled: {
            primary: tokens.COLOR_OPTION_DISABLED_PRIMARY_DARK,
            secondary: tokens.COLOR_OPTION_DISABLED_SECONDARY_DARK,
            tertiary: tokens.COLOR_OPTION_DISABLED_TERTIARY_DARK,
        },
    },
};
//# sourceMappingURL=audi-colors.js.map